import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CurrencyData } from '../../_models/currency';
import { Counts } from '../../_models/data';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';

@Component({
  selector: 'app-currencies',
  templateUrl: './currencies.component.html',
  styleUrl: './currencies.component.css'
})
export class CurrenciesComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  page = 1;
  count: Counts;
  url = this.router.url.slice(1);

  mainHeader = 'List All Currencies';
  formHeader = 'Add New Currency';
  view = '';
  processing = false;
  loading = true;
  buttonText = 'Add New Currency';
  edit = false;

  currencyList: CurrencyData[] = [];
  currencyName = '';
  currencyRef = 0;

  dataForm = this.fb.group({
    ref: [0],
    symbol: ['', Validators.required],
    name: ['', Validators.required],
    code: ['', Validators.required],
  });

  get ref() { return this.dataForm.get('ref'); }
  get symbol() { return this.dataForm.get('symbol'); }
  get name() { return this.dataForm.get('name'); }
  get code() { return this.dataForm.get('code'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {
    if (this.routeParams?.['view'] !== undefined) {
      this.view = this.routeParams['view'];
      this.mainHeader = 'List '+this.view+' Currencies';
    }
    this.page = this.queryParams?.['page'] !== undefined ? this.queryParams['page'] : 1;
    this.getCurrencies(this.page);
  }

  getCurrencies(page: number) {
    this.loading = true;
    this.apiService.getCurrencies(page, this.view).subscribe(data => {
      this.checkService.checkLoggedin(data);
      this.loading = false;
      if (data.success == true) {
        this.count = data.counts;
        this.currencyList = data.data || [];
      } else {
        this.notifyService.showError(data.error.message, 'Error');
      }
    });
  }

  onCreate() {
    const data = {
      ref: this.dataForm.value.ref,
      symbol: this.dataForm.value.symbol,
      name: this.dataForm.value.name,
      code: String(this.dataForm.value.code || '').toUpperCase(),
    };
    if (this.edit === true) {
      this.editCurrency(data);
    } else {
      this.createCurrency(data);
    }
  }

  createCurrency(data) {
    this.processing = true;
    this.buttonText = 'Adding New Currency...';
    this.apiService.createCurrency(data).subscribe(response => {
      this.checkService.checkLoggedin(response);
      this.processing = false;
      if (response.success == true) {
        this.notifyService.showSuccess('Created '+data.code+' as a currency', 'Currency Created');
        this.checkService.closeModal('modal-currency-form');
        this.getCurrencies(this.page);
        this.onCancel();
      } else {
        this.notifyService.showError(response.error.message + '. ' + response.error.additional_message, 'Error');
      }
      this.buttonText = 'Add New Currency';
    });
  }

  editCurrency(data) {
    this.processing = true;
    this.buttonText = 'Saving Changes...';
    this.apiService.editCurrency(data).subscribe(response => {
      this.checkService.checkLoggedin(response);
      this.processing = false;
      if (response.success == true) {
        this.notifyService.showSuccess('Saved changes made to currency', 'Currency Edited');
        this.checkService.closeModal('modal-currency-form');
        this.getCurrencies(this.page);
        this.onCancel();
      } else {
        this.notifyService.showError(response.error.message + '. ' + response.error.additional_message, 'Error');
      }
      this.buttonText = 'Add New Currency';
      this.edit = false;
    });
  }

  getEdit(data: CurrencyData) {
    this.dataForm.patchValue({
      ref: data.ref,
      symbol: data.symbol,
      name: data.name,
      code: data.code,
    });
    this.edit = true;
    this.formHeader = 'Edit '+data.code;
    this.buttonText = 'Edit Currency';
  }

  onCancel() {
    this.edit = false;
    this.dataForm.reset({
      ref: 0,
      symbol: '',
      name: '',
      code: '',
    });
    this.formHeader = this.buttonText = 'Add New Currency';
  }

  changeCurrencyStatus(action: string, ref: number) {
    this.processing = true;
    this.apiService.changeCurrencyStatus({ ref: ref, status: action.toLowerCase() }).subscribe(response => {
      this.checkService.checkLoggedin(response);
      this.processing = false;
      if (response.success == true) {
        this.notifyService.showSuccess('Changes made to currency successfully', 'Currency Modified');
        this.checkService.closeModal();
        this.getCurrencies(this.page);
      } else {
        this.notifyService.showError(response.error.message + '. ' + response.error.additional_message, 'Error');
      }
      document.getElementById('modal-activate-currency')?.click();
      document.getElementById('modal-deactivate-currency')?.click();
      document.getElementById('modal-delete-currency')?.click();
    });
  }

  deleteCurrency(ref: number) {
    this.processing = true;
    this.apiService.deleteCurrency(ref).subscribe(response => {
      this.checkService.checkLoggedin(response);
      this.processing = false;
      if (response.success == true) {
        this.notifyService.showSuccess('Currency removed successfully', 'Currency Deleted');
        this.checkService.closeModal();
        this.getCurrencies(this.page);
      } else {
        this.notifyService.showError(response.error.message + '. ' + response.error.additional_message, 'Error');
      }
      document.getElementById('modal-activate-currency')?.click();
      document.getElementById('modal-deactivate-currency')?.click();
      document.getElementById('modal-delete-currency')?.click();
    });
  }

  getDataFromList(name: string, ref: number) {
    this.currencyName = name;
    this.currencyRef = ref;
  }

  getRouteParams() {
    this.activatedRoute.params.subscribe(params => {
      this.routeParams = params;
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.queryParams = params;
    });
    this.activatedRoute.url.subscribe(() => {
      this.ngOnInit();
    });
  }
}
